import { faChartSimple } from "@fortawesome/pro-regular-svg-icons";

import type { MentionKinds } from "src/base-components/Chat/PromptBox/mentionContent";

/** Chart mention config, shared by the prompt box and sent messages. */
export const CHART_MENTION_KINDS: MentionKinds = {
  chart: { icon: faChartSimple },
};
